// @flow
import { ContactosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    contacto: {},
    listaContactos: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ContactosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { contacto?: {} | null, listaContactos?: [] | null, loading?: boolean, +value ?: boolean };

const Contactos = (state: State = INIT_STATE, action: ContactosAction): any => {
    // console.log(action);
    switch (action.type) {
        case ContactosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ContactosActionTypes.GET_CONTACTO: {
                    return {
                        ...state,
                        contacto: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContactosActionTypes.LIST_CONTACTOS: {
                    return {
                        ...state,
                        listaContactos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContactosActionTypes.UPDATE_CONTACTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        // contacto: action.payload.data,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ContactosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ContactosActionTypes.GET_CONTACTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        contacto: {},
                        loading: false,
                    };
                }
                case ContactosActionTypes.LIST_CONTACTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaContactos: [],
                        loading: false,
                    };
                }
                case ContactosActionTypes.UPDATE_CONTACTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ContactosActionTypes.GET_CONTACTO:
            return { ...state, error: false, loading: true };
        case ContactosActionTypes.LIST_CONTACTOS:
            return { ...state, error: false, loading: true };
        case ContactosActionTypes.UPDATE_CONTACTO:
            return { ...state, error: false, loading: false };
        case ContactosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                contacto: {},
                listaContactos: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Contactos;
